module.exports = __webpack_public_path__ + "img/alumni.54f2a5d1.png";